<template>
    <div class="request-status-select">
        <div class="select is-full-cell">
            <select
                :value="currentStatus"
                :disabled="isLoading"
                @input="handleStatusChange"
            >
                <option
                    v-for="status in statusesList"
                    :key="status.key"
                    :value="status.key"
                >{{ status.value }}</option>
            </select>
        </div>
        <i v-if="isLoading" class="material-icons icon-spin">sync</i>
    </div>
</template>

<script>
import { notifyError } from '@components/Notification';
import { getRequestHasStornoEmail } from '@utilities/api';
import { settings } from '@clientSpecific/utilities/settings';

export default {
    props: {
        // For v-model mode (used in modals)
        value: {
            type: String,
            default: null
        },
        // For immediate mode (used in PlaceholderRequests)
        request: {
            type: Object,
            default: null
        },
        statusesList: {
            type: Array,
            required: true
        },
        // If true, dispatches store action immediately
        // If false, only emits 'input' event for v-model binding
        immediate: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            isLoading: false
        }
    },

    computed: {
        currentStatus() {
            // Support both v-model (value) and request.requestStatus.status
            if (this.value !== null) {
                return this.value;
            }
            return this.request?.requestStatus?.status;
        },
        requestId() {
            return this.request?.id;
        }
    },

    methods: {
        async handleStatusChange(event) {
            const newStatus = event.target.value;
            const previousStatus = this.currentStatus;
            this.isLoading = true;

            // Check for storno email if status is 'canceled' and feature is enabled
            const stornoCheckTag = settings.request?.stornoCheckTag;
            if (stornoCheckTag && newStatus === 'canceled' && this.requestId) {
                try {
                    const response = await getRequestHasStornoEmail(this.requestId, stornoCheckTag);
                    if (!response.data.hasStornoEmail) {
                        if (!confirm('Keine Storno-E-Mail gefunden. Bist du sicher, dass du den Status ändern möchtest?')) {
                            this.isLoading = false;
                            event.target.value = previousStatus;
                            return;
                        }
                    }
                } catch (error) {
                    if (!confirm('Storno-E-Mail konnte nicht geprüft werden. Bist du sicher, dass du den Status ändern möchtest?')) {
                        this.isLoading = false;
                        event.target.value = previousStatus;
                        return;
                    }
                }
            }

            // If immediate mode, dispatch store action
            if (this.immediate && this.request) {
                this.$store.dispatch('changeRequestStatus', {
                    request: this.request,
                    status: newStatus
                }).then(() => {
                    this.isLoading = false;
                    this.$emit('changed', newStatus);
                }, error => {
                    notifyError('Status konnte nicht geändert werden! Server Error!');
                    this.isLoading = false;
                    event.target.value = previousStatus;
                });
            } else {
                // v-model mode: just emit the new value
                this.$emit('input', newStatus);
                this.$emit('changed', newStatus);
                this.isLoading = false;
            }
        }
    }
}
</script>

<style scoped>
.request-status-select {
    display: flex;
    align-items: center;
    gap: 5px;
}
</style>
